import React, {createContext, useContext, useEffect, useMemo, useState} from "react";
import {dictionaries, languageOptions} from "../languages";
import axios from "axios";
import {axiosWithInterceptors} from "../components/common/AxiosInterceptorInitializer";
import {CompanyEnvironmentContext} from "./CompanyEnvironmentContext";
import moment from "moment";

export const LanguageContext = createContext({
  language: localStorage.getItem("language") ? JSON.parse(localStorage.getItem("language")) : languageOptions[0],
  dictionary: dictionaries[localStorage.getItem("language") ? JSON.parse(localStorage.getItem("language")).id : languageOptions[0].id]
});

const LanguageProvider = props => {
  const languageContext = useContext(LanguageContext);
  const companyEnvironmentContext = useContext(CompanyEnvironmentContext);
  const [language, setLanguage] = useState(languageContext.language);
  const [languageHeader, setLanguageHeader] = useState(language.id);

  const dictionary = useMemo(() => {
    let languageId = language?.id || languageOptions[0].id;
    return {
      ...dictionaries[languageId],
      ...companyEnvironmentContext.dictionaries?.[languageId]
    };
  }, [language, companyEnvironmentContext.dictionaries]);

  const get = (key, params) => {
    let res =
      dictionary[key] ||
      dictionary[key.toLowerCase()] ||
      dictionary[key.charAt(0).toLowerCase() + key.slice(1)];
    if (res && params) {
      Object.keys(params).forEach(pKey => {
        res = res.replace(new RegExp(`\\$_\\{${pKey}\\}`, "g"), params[pKey]);
      });
    }
    return res;
  };

  useEffect(() => {
    if (language) {
      localStorage.setItem("language", JSON.stringify(language));
      axios.defaults.headers.common['X-Selected-Language'] = language.id;
      axiosWithInterceptors.defaults.headers.common['X-Selected-Language'] = language.id;
      setLanguageHeader(language.id); // for useEffects
      moment.locale(language.id);
    }
  }, [language]);

  const provider = {
    language,
    dictionary,
    languageHeader,
    get,
    setLanguage: selectedLanguage => {
      setLanguage(selectedLanguage);
    }
  };

  return (
    <LanguageContext.Provider value={provider}>
      {props.children}
    </LanguageContext.Provider>
  );
};

export default LanguageProvider;
